import { render, staticRenderFns } from "./MiniShop.vue?vue&type=template&id=42582509&lang=pug"
import script from "./MiniShop.vue?vue&type=script&lang=js"
export * from "./MiniShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports